export default {
  calendar: {
    today: 'I dag',
    tomorrow: 'I morgen',
    asap: 'Hurtigst muligt',
  },
};
